import { useCallback, useState } from "react";
import PropTypes from 'prop-types';
import CTAs from "./CTAs";
import Dropdown from '../components/Dropdown.js';

const AddNewInstructionsPage = ({ className="" }) => {
      const dropdownContents = ["High", "Medium", "Low"];

    return (
          <div className={`relative shadow-[0px_10px_60px_rgba(0,_0,_0,_0.1)] rounded-3xs bg-neutrals-neutral-50 box-border flex flex-col items-start justify-start max-w-full max-h-full text-left text-9xl text-neutrals-neutral-900 font-open-sans-ff-body-strong border-[1px] border-solid border-neutrals-neutral-100 ${className}`}>
                <div className="flex flex-col items-start justify-start gap-[40px]">
                      <div className="flex flex-col items-start justify-start gap-[24px]">
                            <div className="w-[480px] flex flex-col items-start justify-start pt-6 px-6 pb-0 box-border">
                                  <div className="self-stretch flex flex-col items-start justify-start gap-[24px]">
                                        <div className="self-stretch flex flex-col items-start justify-start pt-0 px-0 pb-6 gap-[6px] border-b-[1px] border-solid border-neutrals-neutral-100">
                                              <b className="relative">Add new instruction</b>
                                              <div className="relative text-sm text-neutrals-neutral-300">Submit your legal inquiry for expert advice.</div>
                                        </div>
                                        <div className="flex flex-col items-start justify-start gap-[6px] text-lg">
                                              <div className="relative font-semibold">Instruction details</div>
                                              <div className="relative text-sm text-neutrals-neutral-300">Enter your billing information.</div>
                                        </div>
                                  </div>
                            </div>
                            <div className="self-stretch flex flex-col items-start justify-start py-0 px-6 text-sm">
                                  <div className="self-stretch flex flex-row items-start justify-start">
                                        <div className="w-[432px] flex flex-col items-start justify-start gap-[16px]">
                                              <div className="self-stretch h-[311px] flex flex-col items-start justify-start gap-[10px]">
                                                    <div className="flex flex-row items-center justify-start gap-[6px]">
                                                          <div className="relative font-semibold">Provide detailed description of the instruction</div>
                                                          <img className="w-5 relative h-5 overflow-hidden shrink-0" alt="" src="assets/help-circle.svg" />
                                                    </div>
                                                    <div className="self-stretch flex-1 shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 flex flex-col items-start justify-start p-4 text-base text-neutrals-neutral-300 border-[1px] border-solid border-neutrals-neutral-100">
                                                          <div className="relative">Enter instruction details here</div>
                                                    </div>
                                              </div>
                                              <Dropdown
                                                title="Select the priority level"
                                                placeholder="Select priority level"
                                                width="432px"
                                                icon="assets/help-circle.svg"
                                                dropdownContents={dropdownContents}
                                              />
                                        </div>
                                  </div>
                            </div>
                      </div>
                      <div className="flex flex-row items-start justify-start pt-0 px-6 pb-6 gap-[12px] text-sm">
                        <CTAs
                        type="Ghostbtn"
                        text="Cancel"
                        textColor="text-neutrals-neutral-900"
                        bgColor="bg-neutrals-neutral-50"
                        borderColor="border-neutrals-neutral-100"
                        width="w-[165px] md:w-[210px]"
                        position="relative"
                        />

                        <CTAs
                        type="Primarybtn"
                        text="Continue"
                        textColor="text-neutrals-neutral-50"
                        bgColor="bg-primary-primary-500"
                        borderColor="border-primary-primary-500"
                        width="w-[165px] md:w-[210px]"
                        position="relative"
                        />
                      </div>
                </div>
          </div>);
};

AddNewInstructionsPage.propTypes = {
    className: PropTypes.string
};

export default AddNewInstructionsPage;